import React, { useContext } from "react";
import { auth, signOut } from "../index";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { PiWindmillFill } from "react-icons/pi";
import { GrLanguage } from "react-icons/gr";
import { RiLogoutCircleRLine, RiLogoutCircleLine } from "react-icons/ri";
import { Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import farmName from "../assets/Header/farm.png";
import NotificationBell from "./Notifications/NotificationBell";

const Header = ({ setIsLoggedIn }) => {
  const { userData, setToken, setUserData } = useContext(UserContext);
  const [t, i18n] = useTranslation(); //translation hook
  const navigate = useNavigate();

  const handleSelect = (lang) => {
    if (lang == "ar") {
      document.body.classList.add("rtl");
      document.body.style.direction = "rtl";
      i18n.changeLanguage(lang);
    } else {
      document.body.classList.remove("rtl");
      document.body.style.direction = "ltr";
      i18n.changeLanguage(lang);
    }
  };

  const handleLogout = () => {
    try {
      signOut(auth); // Sign out from Firebase Authentication
      setToken(null);
      setUserData(null);
      setIsLoggedIn(false);
      navigate("/login");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={farmName}
            alt="Farm"
            style={{ width: "24px", height: "24px" }}
          />
          {i18n.language === "en" && (
            <span
              style={{
                paddingLeft: "10px",
                fontSize: "20px",
                weight: "500",
                height: "25px",
                lineHeight: "25px",
              }}
            >
              {userData?.Farm.name}
            </span>
          )}
          {i18n.language === "ar" && (
            <span style={{ paddingRight: "10px", fontSize: "20px" }}>
              {userData?.Farm.name}
            </span>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <NotificationBell />
          <Dropdown onSelect={handleSelect}>
            <Dropdown.Toggle
              style={{ background: "white", color: "#372068", border: "none" }}
            >
              <GrLanguage
                size={20}
                style={{ color: "inherit", marginLeft: "5px" }}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="en">{t("English")}</Dropdown.Item>
              <Dropdown.Item eventKey="ar">{t("Arabic")}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {i18n.language === "en" && (
            <RiLogoutCircleRLine
              size={25}
              style={{
                cursor: "pointer",
                marginRight: "15px",
                color: "#372068",
              }}
              onClick={handleLogout}
            />
          )}
          {i18n.language === "ar" && (
            <RiLogoutCircleLine
              size={25}
              style={{
                cursor: "pointer",
                marginLeft: "15px",
                color: "#372068",
              }}
              onClick={handleLogout}
            />
          )}
        </div>
      </div>
      <hr
        style={{
          borderColor: "#e2b9c6",
          margin: "20px",
        }}
      ></hr>
    </>
  );
};

export default Header;
